import { Duration } from "luxon";

export const SILO_IS_OLD_DURATION: Duration = Duration.fromObject({ days: 10 });
